// extracted by mini-css-extract-plugin
module.exports = {"minimumScreenWidth":"320px","mobileScreenWidth":"600px","user":"style_user__1jLOC"};